import { render, staticRenderFns } from "./informacion.vue?vue&type=template&id=4df30cf8"
import script from "./informacion.vue?vue&type=script&lang=js"
export * from "./informacion.vue?vue&type=script&lang=js"
import style0 from "./informacion.vue?vue&type=style&index=0&id=4df30cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports